/**
 * product-block-bom.js
 *
 * Swaps the contents of a [data-product-block-bom] list when the
 * selected variant changes. Reads the per-variant data from a sibling
 * <script type="application/json" data-product-block-bom-data> tag
 * rendered by snippets/product-block-bom.liquid.
 *
 * Self-initializing and idempotent: it scans every product container
 * on DOMContentLoaded, re-scans on Shopify section reloads, and tags
 * each container so it never binds twice.
 */
(function () {
  var PRODUCT_CONTAINER_SELECTOR = '[data-section-type="product"]';
  var BOM_LIST_SELECTOR = '[data-product-block-bom]';
  var BOM_DATA_SELECTOR = '[data-product-block-bom-data]';
  var BOUND_FLAG = 'productBlockBomBound';

  function parseVariantData(container) {
    var dataEl = container.querySelector(BOM_DATA_SELECTOR);
    if (!dataEl) return null;
    try {
      return JSON.parse(dataEl.textContent);
    } catch (err) {
      return null;
    }
  }

  function findBomForVariant(variantData, variantId) {
    if (!Array.isArray(variantData)) return null;
    for (var i = 0; i < variantData.length; i++) {
      if (variantData[i].id === variantId) {
        return variantData[i].bom_contents;
      }
    }
    return null;
  }

  function renderBomList(listEl, items) {
    listEl.innerHTML = '';
    var hasItems = Array.isArray(items) && items.length > 0;
    if (!hasItems) {
      var emptyText = listEl.dataset.emptyText || '';
      if (emptyText) {
        var emptyLi = document.createElement('li');
        emptyLi.className = 'product-block-bom__empty';
        emptyLi.textContent = emptyText;
        listEl.appendChild(emptyLi);
      }
      return;
    }
    var fragment = document.createDocumentFragment();
    items.forEach(function (item) {
      var li = document.createElement('li');
      li.innerHTML = item;
      fragment.appendChild(li);
    });
    listEl.appendChild(fragment);
  }

  function refreshOpenAccordionHeight(listEl) {
    var content = listEl.closest('.collapsible-content');
    if (!content || !content.classList.contains('is-open')) return;
    var inner = content.querySelector('.collapsible-content__inner');
    if (inner) content.style.height = inner.offsetHeight + 'px';
  }

  function bind(container) {
    if (container[BOUND_FLAG]) return;
    var listEl = container.querySelector(BOM_LIST_SELECTOR);
    if (!listEl) return;
    var variantData = parseVariantData(container);
    if (!variantData) return;

    container[BOUND_FLAG] = true;

    container.addEventListener('variantChange', function (evt) {
      var variant = evt.detail && evt.detail.variant;
      if (!variant) return;
      var currentList = container.querySelector(BOM_LIST_SELECTOR);
      if (!currentList) return;
      renderBomList(currentList, findBomForVariant(variantData, variant.id));
      refreshOpenAccordionHeight(currentList);
    });
  }

  function init(scope) {
    var root = scope || document;
    if (root.matches && root.matches(PRODUCT_CONTAINER_SELECTOR)) {
      bind(root);
      return;
    }
    var containers = root.querySelectorAll
      ? root.querySelectorAll(PRODUCT_CONTAINER_SELECTOR)
      : [];
    containers.forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Re-init for theme editor section reloads and quick-shop modals
  // that inject product HTML after initial load.
  document.addEventListener('shopify:section:load', function (evt) {
    init(evt.target);
  });
  document.addEventListener('product:loaded', function (evt) {
    init(evt.target || document);
  });
})();
